// Fellowship.js
import React from "react";


const fellowships = [
  {
    title: "Youth Fellowship",
    day: "Friday",
    time: "5:00 PM - 7:00 PM",
    image: "/images/fellowship1.jpg",
    description: "Engaging youth with spiritual activities, games, and outreach programs."
  },
  {
    title: "Women’s Fellowship",
    day: "Saturday",
    time: "10:00 AM - 12:00 PM",
    image: "/images/fellowship2.jpg",
    description: "Women gathering to grow spiritually, share experiences, and serve the community."
  }
];

const Fellowship = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center mb-5">Fellowship Programs</h2>
      <div className="row g-4">
        {fellowships.map((item, index) => (
          <div className="col-md-6" key={index}>
            <div className="card shadow-sm h-100">
              <img
                src={item.image}
                className="card-img-top"
                alt={item.title}
                style={{ height: "250px", objectFit: "cover" }}
              />
              <div className="card-body" style={{ backgroundColor: "#FFF4E0" }}>
                <h5 className="card-title">{item.title}</h5>
                <p><strong>Day:</strong> {item.day}</p>
                <p><strong>Time:</strong> {item.time}</p>
                <p>{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Fellowship;
